import styled from 'styled-components';
import { CardContent } from '@prisjakt/ui/card';
import { layout } from 'src/components/base';

export const StyledCardContent = styled(CardContent)`
  && {
    justify-content: space-between;
    padding-top: 0;
    padding-bottom: ${layout.measurements.spacing050};
    gap: ${layout.measurements.spacing050};
  }
`;

export const StyledFirstSection = styled.div`
  > :not(:last-child) {
    margin-bottom: ${layout.measurements.spacing025};
  }
`;

export const StyledSecondSection = styled.div`
  display: flex;
  flex-direction: column;
`;
